export enum UserTypesE {
  Undefined = 'Undefined',
  Chirp = 'Chirp',
  WarrCloud = 'WarrCloud',
}

/** Rooftop permission role from profile API (rooftopPermissions[].role). */
export enum RooftopPermissionRoleE {
  ChirpOnly = 'ChirpOnly',
  WarrQueueLead = 'WarrQueueLead',
  WarrQueueOnly = 'WarrQueueOnly',
}
